import React, { FunctionComponent } from 'react'
import { ID } from '../../../../../../types/UtilityTypes'
import styles from './TaskLine.module.sass'
import { Link } from 'react-router-dom'
import UserPanel from '../../../../../data-components/elements/UserElement/UserElement'
import { TaskStatus } from '../../../../../../constants/enums'
import DeadlinePanel from '../../../../../data-components/elements/DeadlinePanel/DeadlinePanel'
import { Priority } from '../../../../../data-components/pickers/PriorityPicker/PriorityPicker'
import { urlWithParams } from '../../../../../../http/utils'
import { ROUTES } from '../../../../../../http/routes'
import { useRootDispatch, useRootSelector } from '../../../../../../utils/hooks'
import { lineTasksSelector } from '../../../../../../utils/selectors'
import TaskTab from '../../../../../navigation/TaskTabs/TaskTab'
import Results from '../../../../../data-components/Results/Results'
import { galleryActions } from '../../../../../../redux/global/gallery/gallery-actions'
import clsx from 'clsx'
import { Classes } from '../../../../../../styles'

interface Props {
    parentId: ID,
    index: number,
}

const TaskLine: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()
    const line = useRootSelector(lineTasksSelector(props.parentId))
    return <>
        {
            line.map((task, index) => {
                const url = urlWithParams({taskId: task.id})(ROUTES.TASK)
                return <div key={task.id} className={clsx(styles.task, {
                    [styles.parent]: index === 0,
                    [styles.last]: index === line.length - 1,
                })}>
                    {
                        index === 0 && <div className={clsx(styles.line, Classes.cGrey, Classes.f9, Classes.justifyCenter)}>
                            Линия задач {props.index + 1}
                        </div>
                    }
                    <Link className={styles.name} to={url}>
                        <TaskTab active task={task}/>
                    </Link>
                    <Link to={url}>
                        <Results
                            className={styles.result}
                            mode={'task'}
                            taskId={task.id}
                            onClick={current => dispatch(galleryActions.open({
                                current,
                                type: 'task',
                                objectId: task.project_work_object_id,
                                tasksId: [task.id],
                            }))}
                        />
                    </Link>
                    <Link to={url}>
                        {
                            task.target_user &&
                            <UserPanel disabled user={task.target_user}/>
                        }
                    </Link>
                    <Link className={Classes.justifyCenter} to={url}>
                        {
                            task.status_id !== TaskStatus.CLOSED &&
                            <DeadlinePanel
                                value={task.deadline_at}
                                deadline_text={task.deadline}
                                deadline_type={task.deadline_type}
                            />
                        }
                    </Link>
                    <Link to={url}>
                        {
                            task.status_id !== TaskStatus.REQUESTED &&
                            <Priority
                                className={styles.priority}
                                priority={task.priority_id}
                            />
                        }
                    </Link>
                </div>
            })
        }
    </>
}

export default TaskLine